import { FC } from 'react';

import { Stack } from '@mui/material';

import { IRecommendedSpeciality } from '../../model/types';
import Speciality from './Speciality';

interface ISpecialityListProps {
  specialities: IRecommendedSpeciality[];
  ignoreBreakpoints?: boolean;
}

const SpecialityList: FC<ISpecialityListProps> = ({ specialities, ignoreBreakpoints }) => {
  return (
    <Stack className="speciality-list" gap="12px">
      {specialities.map((speciality) => {
        const { code, name } = speciality;
        return <Speciality key={`${name}-${code}`} speciality={speciality} ignoreBreakpoints={ignoreBreakpoints} />;
      })}
    </Stack>
  );
};

export default SpecialityList;
